{
  "version": 1,
  "asset_id": "69a6f2bd-341b-4026-bafe-1a07bb281f77",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/69a6f2bd-341b-4026-bafe-1a07bb281f77/svc-ecommerce-seo-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/69a6f2bd-341b-4026-bafe-1a07bb281f77/svc-ecommerce-seo-1200.webp",
  "original_filename": "svc-ecommerce-seo-1200.webp",
  "size": 34612,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:46Z"
}
